//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DomainFiltering from "./components/DomainFiltering/index";
import KeywordFiltering from "./components/KeywordFiltering/index";
export default {
  props: ["deviceDid", "deviceSn", 'data'],
  components: {
    DomainFiltering: DomainFiltering,
    KeywordFiltering: KeywordFiltering
  },
  data: function data() {
    return {
      activename: 'DomainFiltering'
    };
  },
  created: function created() {}
};